var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { staticClass: "search-result-pagination" }, [
    _c(
      "li",
      {
        class: { disabled: Number(_vm.paginationPage) === 1 },
        on: { click: _vm.decrement },
      },
      [_c("i", { staticClass: "lnr lnr-chevron-left" })]
    ),
    _vm._v(" "),
    _c("li", { staticStyle: { width: "100px", position: "relative" } }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.number",
            value: _vm.paginationPage,
            expression: "paginationPage",
            modifiers: { number: true },
          },
        ],
        attrs: { id: "pagination-page", type: "number", autocomplete: "off" },
        domProps: { value: _vm.paginationPage },
        on: {
          keydown: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.submit.apply(null, arguments)
          },
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.paginationPage = _vm._n($event.target.value)
          },
          blur: function ($event) {
            return _vm.$forceUpdate()
          },
        },
      }),
      _vm._v(" "),
      _c("div", { attrs: { id: "pagination-count" } }, [
        _vm._v("\n            из " + _vm._s(_vm.maxPages) + "\n        "),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "li",
      {
        class: {
          disabled: Number(_vm.paginationPage) === Number(_vm.maxPages),
        },
        on: { click: _vm.increment },
      },
      [_c("i", { staticClass: "lnr lnr-chevron-right" })]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }